import { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from "firebase/database";

import firebase from "../firebase";

import upload from "../assets/upload.svg";
import matchHero from "../assets/matches.svg";
import { Link } from "react-router-dom";
import profilePic1 from "../assets/profilePic1.jpg";
import profilePic2 from "../assets/profilePic2.jpg";
import profilePic3 from "../assets/profilePic3.jpg";

// Match for introvert/extrovert, fav past time, expertise, mentor mandatory, mentorship goal (weight these differently in final version), connection type, bootcamp connection

// Additions
// Skill level for mentee?
// experience level - not matching by this for initial version - could be randomized
// Identifies with option - put this into array/loop through it so user can select multiple options

const Matches = () => {
  const [firedata, setFiredata] = useState([]);
  const [latestUser, setLatestUser] = useState([]);
  const [matchData, setMatchData] = useState(["ddd"]);

  console.log(latestUser);
  useEffect(() => {
    const database = getDatabase(firebase);
    const dbRef = ref(database);
    onValue(dbRef, (response) => {
      const newState = [];
      const data = response.val();

      for (let key in data) {
        // pushing the values from the object into our newState array
        newState.push({ personalID: key, data: data[key] });
      }
      if (newState.length > 0) {
        
        // const lastArray1 = Object.entries(lastOne)
        // console.log("last",lastArray1[1][1])
        const mentorResults = newState.filter(
          (item) => item.data.mentorType === "Mentor"
        );
        const menteeResults = newState.filter(
          (item) => item.data.mentorType === "Mentee"
        );

        const lastOne = menteeResults.pop();
        setLatestUser(lastOne);
        console.log(lastOne)
        const results = mentorResults.filter(
          (item) =>
            // item.data.expLevel === lastOne.data.expLevel &&
            item.data.expertise === lastOne.data.expertise &&
            item.data.bootcamp === lastOne.data.bootcamp &&
            item.data.connectType === lastOne.data.connectType &&
            item.data.goals === lastOne.data.goals &&
            item.data.personality === lastOne.data.personality &&
            item.data.sports === lastOne.data.sports
        );
        if(results.length < 2) {
          setMatchData(mentorResults.slice(0, 3))
        } else {
          setMatchData(results.slice(0, 3));
        }
        
      }
    });
  }, []);

  console.log("matchdata", matchData);
  return (
    <div className="wrapper">
      <section className="matches">
        <div className="hero">
          <img src={matchHero} alt="" />
        </div>
        <div className="details">
          <h3>Here are your mentor matches</h3>
          <ul className="matchesList">
            {matchData?.map((profile, index) => (
              <li key={index}>
                <Link to={`/personal/${profile?.personalID}`}>
                  <span className="imageSpan">
                    <img
                      src={profile?.data?.image[0].data_url}
                      alt="profile pic"
                    />
                  </span>
                  <p>
                    {profile?.data?.name?.first} {profile?.data?.name?.last}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
          <div className="description">
            <p className="instructions">Sprout tip:</p>
            <p className="instructions">
              Read each mentor profile carefully and decide who is the best
              match for you. Then, send them an email and introduce yourself!
            </p>
            <p className="instructions">
              To help get you started, here’s an email prompt you can use. Feel
              free to modify it!
            </p>
            <p className="example">
              Dear [mentor name], I’m an early career{" "}
              {latestUser?.data?.expertise} and I was matched with you in the
              Sprout mentor app. I would like to ask you about your path into
              the field. Could we set up a time to chat? 
            </p>
            <p className="example">Thanks, </p>
            <p className="example">{latestUser?.data?.name?.first}</p>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Matches;
